import { styled } from '@mui/material/styles';

export const GoogleWalletStyledButton = styled('button')(() => ({
	appearance: 'none',
	border: 0,
	padding: 0,
	margin: 0,
	background: 'transparent',
	display: 'inline-flex',
	alignItems: 'center',
	justifyContent: 'center',
	lineHeight: 0,
	cursor: 'pointer',
	width: 'auto',
	borderRadius: '28px',

	'&[aria-disabled="true"]': {
		opacity: 0.6,
		cursor: 'not-allowed',
	},

	'& svg, & img': {
		display: 'block',
		width: 'auto',
		height: 'auto',
	},
}));
